import React, { useContext, useEffect, useState } from "react";
import { ReactTyped } from "react-typed";
import Profile from "../../Profile.png";
import ParticlesContainer from "../ParticlesContainer/ParticlesContainer";
import { IsHomePageContext } from "../Provider/IsHomePage";
import SplineObject from "../SplineObject/SplineObject";

function Header() {
  const [height, setHeight] = useState(window.innerHeight);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    const url = "https://drive.google.com/uc?export=download&id=1OJQUg6Y2ym6YeF0ZT79ATsFLFpjQ9hUn";
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.download = "Ishan_Tharindu_CV.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const { isHomePage } = useContext(IsHomePageContext);

  return (
    <div className="header-wraper" style={{ height: height }}>
      <div
        style={{
          position: "absolute",
          inset: 0,
          opacity: isHomePage ? 1 : 0,
          visibility: isHomePage ? "visible" : "hidden",
          transition: "opacity 1s ease-in-out, visibility 1s ease-in-out",
          zIndex: 1,
        }}
      >
        <ParticlesContainer />
      </div>

      <div className="new-header-flex container">
        {!isMobile && (
          <div className="main-info-left" style={{ flex: 1 }}>
            <SplineObject />
          </div>
        )}

        <div className="main-info" style={{ flex: 1, textAlign: "left", alignItems: "flex-start" }}>
          <div className="profile-container mb-4">
            <img className="profile-image" src={Profile} alt="Ishan Tharindu" />
          </div>

          <h1 className="mb-2">Ishan Tharindu</h1>
          <h4 className="mb-3" style={{ color: 'var(--text-secondary)', fontWeight: '600' }}>Associate Software Engineer</h4>
          <div className="typed-text-container mb-4">
            <ReactTyped
              className="typed-text"
              strings={[
                "Full-Stack Developer",
                "Web3 & Blockchain Enthusiast",
                "Fintech Solutions",
              ]}
              typeSpeed={50}
              backSpeed={30}
              loop
            />
          </div>

          <p className="text-secondary mb-4" style={{ fontSize: "1.1rem", maxWidth: "500px" }}>
            Architecting non-custodial wallets and high-performance APIs with a focus on
            scalable decentralised solutions.
          </p>

          <div className="d-flex align-items-center flex-wrap gap-4">
            <button onClick={handleClick} className="btn-main-offer m-0">
              Download CV <i className="fas fa-download ms-2"></i>
            </button>

            <div className="social-media m-0">
              <a href="https://www.linkedin.com/in/ishantharindu" target="_blank" rel="noreferrer" className="btn-social-media">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="https://github.com/gitgunawardhana" target="_blank" rel="noreferrer" className="btn-social-media">
                <i className="fab fa-github"></i>
              </a>
              <a href="https://web.facebook.com/g.ishantharindu8/" target="_blank" rel="noreferrer" className="btn-social-media">
                <i className="fab fa-facebook-square"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
